import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/app/tenant/links")({
  // Keep the rest of the query and the hash, like the other legacy redirects.
  beforeLoad: ({ location }) => {
    const params = new URLSearchParams(location.searchStr);
    params.set("tab", "links");
    throw redirect({
      href: `/app/tenant/subscriptions?${params}${location.hash ? `#${location.hash}` : ""}`,
      replace: true,
    });
  },
});
